/*
  Everlles: switch the product gallery when an Easify option value is chosen.

  Works for any Easify option whose selected value contains a finish keyword (rose gold / silver /
  gold / black). The gallery image to show is found by its ALT text: tag the photo in Shopify admin
  with an alt ending in " - silver", " - gold", " - black" or " - rose gold".
  No per-product configuration beyond the alt text.

  Easify manages its inputs itself and does not always fire native change events, so the selected
  value is polled (cheap: a handful of querySelector calls every 300ms, only on pages that have both
  an Easify option set and a Dawn media gallery).
*/
(function () {
  var KEYS = ['rose gold', 'silver', 'gold', 'black'];
  var last = null;
  var seeded = false;
  // Everlles 2026-09-28: only a REAL customer interaction may switch the gallery. easify-tweaks.js
  // pre-selects Silver with synthetic (untrusted) pointer events ~600ms after load, which used to be
  // read as a change and replaced the hero photo with the plain variant photo.
  var userTouched = false;
  function markTouch(e) {
    if (e.isTrusted && e.target.closest && e.target.closest('.tpo_option-set-wrapper')) userTouched = true;
  }
  document.addEventListener('pointerdown', markTouch, true);
  document.addEventListener('keydown', markTouch, true);
  document.addEventListener('change', markTouch, true);

  function norm(s) {
    return String(s || '').trim().toLowerCase();
  }

  function keyFor(value) {
    var v = norm(value);
    for (var i = 0; i < KEYS.length; i++) {
      if (v.indexOf(KEYS[i]) !== -1) return KEYS[i];
    }
    return null;
  }

  function mediaIdFor(key) {
    var items = document.querySelectorAll('.product__media-list .product__media-item[data-media-id]');
    for (var i = 0; i < items.length; i++) {
      var img = items[i].querySelector('img');
      var alt = norm(img && img.getAttribute('alt'));
      if (alt.slice(-(key.length + 2)) === '- ' + key || alt.slice(-(key.length + 1)) === '-' + key) {
        return items[i].getAttribute('data-media-id');
      }
    }
    return null;
  }

  function selectedFinish() {
    var wrapper = document.querySelector('.tpo_option-set-wrapper');
    if (!wrapper) return null;
    var picked = wrapper.querySelectorAll(
      'label.tpo_is_checked_swatches input, input.tpo_image-swatches-input:checked, input.tpo_color-swatches-input:checked, input.tpo_radio-button:checked, select.tpo_option-input'
    );
    for (var i = 0; i < picked.length; i++) {
      var el = picked[i];
      var value = el.tagName === 'SELECT' ? el.options[el.selectedIndex] && el.options[el.selectedIndex].text : el.value;
      var key = keyFor(value);
      if (key) return key;
    }
    return null;
  }

  function tick() {
    // Wait until Easify has rendered its inputs, then remember the default selection
    // WITHOUT switching, so the page still opens on its hero image.
    if (!seeded) {
      if (!document.querySelector('.tpo_option-set-wrapper input, .tpo_option-set-wrapper select')) return;
      last = selectedFinish();
      seeded = true;
      return;
    }
    var key = selectedFinish();
    if (key === last) return;
    last = key;
    if (!userTouched) return;
    if (!key) return;
    var mediaId = mediaIdFor(key);
    if (!mediaId) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    gallery.setActiveMedia(mediaId, true);
  }

  function start() {
    if (!document.querySelector('media-gallery')) return;
    setInterval(tick, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
